import { Outlet, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { useGetInstituteProgress } from "../../../hooks/useGetInstituteProgress";
import { instituteArticlesData } from "../../../instituteArticles/instituteArticlesData";

export default function AgentInstitute() {
  const navigate = useNavigate();
  const [instituteArticles, setInstituteArticles] = useState([]);
  const articles = instituteArticlesData.map(({ name, revision }) => ({
    name,
    revision,
  }));

  const {
    isPending: isInstitutePending,
    isSuccess: isInstituteSuccess,
    error: instituteError,
    data: instituteData,
  } = useGetInstituteProgress(articles);

  useEffect(() => {
    if (instituteError) {
      navigate("/error", {
        state: {
          code: instituteError.code,
          message: instituteError.message,
        },
      });
    }
  }, [instituteError]);

  useEffect(() => {
    if (isInstituteSuccess) {
      setInstituteArticles(instituteData);
    }
  }, [isInstituteSuccess, instituteData]);

  return (
    <div className="main">
      <Outlet context={{ instituteArticles, isInstitutePending }} />
    </div>
  );
}
